var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnqualified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    fill: "#FFFFFF",
    cx: 75,
    cy: 75.2,
    r: 74.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Unqualified_Icon_Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    fill: "#888888",
    d: "M75,35c-22.2,0-40.2,18-40.2,40.2s18,40.2,40.2,40.2s40.2-18,40.2-40.2c0,0,0,0,0,0 C115.2,53,97.2,35,75,35z M42.8,75.2C42.8,57.4,57.2,43,74.9,43c0,0,0.1,0,0.1,0l0,0c7.1,0,14.1,2.4,19.7,6.8L49.6,94.9 C45.2,89.3,42.8,82.3,42.8,75.2z M75,107.4c-7.1,0-14.1-2.4-19.7-6.8l45.1-45.1c4.4,5.6,6.8,12.6,6.8,19.7 C107.2,93,92.8,107.3,75,107.4C75,107.3,75,107.3,75,107.4L75,107.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnqualified);
export default __webpack_public_path__ + "static/media/unqualified.cf7b9411130a3d68451535331e9491eb.svg";
export { ForwardRef as ReactComponent };